<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form class="form_cls" :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent>
      <!-- <el-form-item label="">
        <el-input v-model="filters.wwid" placeholder="WWID"></el-input>
      </el-form-item> -->
      <el-form-item label="">
        <el-input v-model="filters.name" placeholder="姓名"></el-input>
      </el-form-item>
      <!-- <el-form-item label="医院编码">
        <el-input v-model="filters.bwacctnumber" placeholder="医院编码"></el-input>
      </el-form-item> -->
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          v-if="!item.IsHide"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="table_top_div">
      <div>
        <el-table
          border
          :max-height="tableHeight"
          :data="users"
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA' }"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
        >
          <!-- <el-table-column sortable type="selection" width="50">
      </el-table-column>-->
          <el-table-column type="index" width="60">
            <template slot="header" slot-scope="{}">
              <span style="padding: 8px 0">
                序号
                <span class="caret-wrapper" style="width: 0px"></span>
              </span>
              <!-- <span class="caret-wrapper" style="padding-top: 0px"></span> -->
            </template>
          </el-table-column>
          <!-- <el-table-column sortable prop="WWID" label="WWID" min-width="100"></el-table-column> -->
          <el-table-column sortable prop="Name" label="姓名" width=""></el-table-column>
          <el-table-column sortable prop="position_code" label="岗位号" min-width="120"></el-table-column>
          <el-table-column sortable prop="Level_3_string" label="大区" min-width="100"></el-table-column>
          <el-table-column sortable prop="old_Level_3_string" label="原大区" min-width="120"></el-table-column>
          <el-table-column sortable prop="Level_4_string" label="小区" min-width="100"></el-table-column>
          <el-table-column sortable prop="old_Level_4_string" label="原小区" min-width="120"></el-table-column>
          <el-table-column sortable prop="role_name" label="角色（一线销售/小区经理）" min-width="220"></el-table-column>
          <!-- <el-table-column sortable prop="Level_4" label="释放" min-width="120"></el-table-column> -->
          <el-table-column sortable prop="approval_status" label="审批状态" min-width="200"></el-table-column>
          <el-table-column label="操作" width="160">
            <template slot="header" slot-scope="{}">
              <span style="padding: 8px 0">
                操作
                <span class="caret-wrapper" style="width: 0px"></span>
              </span>
            </template>
            <template scope="scope">
              <el-link type="primary" @click="handledetails(scope.row)">
                <i class="el-icon-tickets"></i>
                详情
              </el-link>
              <!-- <el-link type="primary" @click="handleEdit(scope.row)">
                &nbsp;|&nbsp;
                <i class="el-icon-edit"></i>
                编辑
              </el-link> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--工具条-->
      <div class="toolbar_div">
        <el-col :span="24" class="toolbar">
          <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
          <el-pagination
            :current-page="page"
            :background="true"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="50"
            :total="total"
            style="float: right"
          ></el-pagination>
        </el-col>
      </div>
    </div>
    <el-dialog title="人岗关系上传" :visible.sync="dialogVisible1" width="30%" :before-close="handleClose">
      <el-form ref="form1" :model="form1" :rules="editFormRules1" label-width="80px" label-position="left">
        <el-form-item label="立即生效" :required="true">
          <el-switch @change="isimediate_change" v-model="form1.isimediate"></el-switch>
        </el-form-item>
        <el-form-item label="生效日期" :required="true">
          <el-date-picker :disabled="form1.isimediate" v-model="form1.date" type="date" placeholder="请选择"></el-date-picker>
        </el-form-item>
        <el-upload
          style="display: inline-block; margin-right: 20px; padding-bottom: 12px"
          class="upload-demo"
          ref="upload"
          action="/images/Upload/Flie"
          :headers="token"
          :show-file-list="false"
          :on-success="handleSuccess"
          :before-upload="handlebefore"
          :on-error="handonerror"
        >
          <el-button type="primary">上传</el-button>
          <el-button @click="btn_up_2(form1.filepath)" v-if="form1.filepath" type="primary">预览</el-button>
        </el-upload>
        <br />
        <el-button type="primary" @click="plmb_dc">模版导出</el-button>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="plgx_submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="导出" :visible.sync="DC_MODE" width="30%" :before-close="handleClose">
      <el-form ref="dc_form" :model="dc_form" :rules="editFormRules1" label-width="140px" label-position="left">
        <el-form-item label="更新批号" :required="true">
          <el-select v-model="versions" placeholder="请选择">
            <el-option v-for="item in versions_list" :label="item" :value="item"></el-option>
          </el-select>
          <!-- <el-input v-model="dc_form.code" placeholder="更新批号"></el-input> -->
        </el-form-item>
        <!-- <el-button type="primary"  @click="mode_uplode">导出</el-button> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DC_MODE = false">关 闭</el-button>
        <el-button type="primary" @click="mode_uplode">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import util from '@/../util/date'
import {
  Employee_GetPosition_ClaimApprovalNO,
  EmployeeUpdateEmployeeLevel,
  Employee_EmployeeExportExcel,
  store_data_ExportStore,
  store_data_Reback_Store,
  member_overrun_ExportExcel,
  EmployeeUpdateEmplovee,
  EmployeeImprotUpdateList,
  EmployeeGetVersionArr,
} from '@/api/api'
import { getButtonList } from '@/promissionRouter'
import Toolbar from '@/components/Toolbar'

export default {
  components: { Toolbar },
  data() {
    return {
      versions_list: [],
      dc_form: {},
      versions: '',
      DC_MODE: false,
      tableHeight: 0,
      form1: {
        isimediate: false,
        filepath: '',
        date: '',
      },
      editFormRules1: {},
      token: {},
      LJGX: true,
      dialogVisible1: false,
      form: {},
      titles: '详情',
      dialogVisible: false,
      SalesOperation_if: false,
      edit_if_2: false,
      edit_if: true,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      filters: {
        pageSize: 50,
      },
      users: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
    }
  },
  methods: {
    plmb_dc() {
      location.href =
        'https://share-ui.oss-cn-shanghai.aliyuncs.com/202308_JJSVMDM/data_template/%E4%BA%BA%E5%B2%97%E5%85%B3%E7%B3%BB%E4%B8%8A%E4%BC%A0_%E6%A8%A1%E6%9D%BF.xlsx'
    },
    mode_uplode() {
      let para = this.filters
      para.version = this.versions
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      Employee_EmployeeExportExcel(para).then((res) => {
        this.DC_MODE = false
        loading.close()
        window.open('/api' + res.data.response)
      })
    },
    btn_up_2(e) {
      // console.log(this.form.file_urls)
      //preview.51i.cc/onlinePreview?url=https://stg-jdp.51i.cc/flie/082915561111e2ff1ef57cc73cd3da78d464b58e2.png&watermarkTxt=MasterData
      https: window.open('https://preview.51i.cc/onlinePreview?url=' + encodeURIComponent('https://' + location.host + '/' + e))
    },
    isimediate_change(e) {
      if (e == true) {
        this.form1.date = ''
      }
    },
    async plgx_submit() {
      // if(this.form1.isimediate){
      //     this.form1.date =''
      // }
      if (!this.form1.isimediate && !this.form1.date) {
        this.$message({
          message: '请选择生效时间',
          type: 'error',
        })
        return
      }
      if (!this.form1.filepath) {
        this.$message({
          message: '请上传批量更新文件',
          type: 'error',
        })
        return
      }
      const { data } = await EmployeeImprotUpdateList(this.form1)
      if (data.success) {
        this.$message({
          message: data.msg,
          type: 'success',
        })
        this.getModules_search()
        this.dialogVisible1 = false
      } else {
        this.$message({
          message: data.msg,
          type: 'error',
        })
      }
    },
    rggx_upload() {
      this.dialogVisible1 = true
    },
    handleClose(done) {
      done()
    },
    // ExportAccount () {
    //   // let para = this.filters
    //   var organization_id = localStorage.getItem("organization_id");
    //   let para = {
    //     organization_id: organization_id
    //   };
    //   //  para.account_manager = para.account_manager.toString()
    //   //  window.open("​/api​/store_data​/ExportStore?")
    //   member_overrun_ExportExcel(para).then((res) => {
    //     //window.open("http://47.103.87.196:8082" + res.data.msg);
    //     window.location.href = res.data.msg;
    //   });
    // },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == '' ? '' : util.formatDate.format(new Date(row.CreateTime), 'yyyy-MM-dd')
    },
    handleCurrentChange(val) {
      this.page = val
      this.getModules()
    },
    getModules_search() {
      this.page = 1
      this.getModules()
    },
    postUpdateEmployeeLevel() {
      EmployeeUpdateEmployeeLevel().then((x) => {
        if (x.data.success) {
          this.$message.success(x.data.msg)
        } else {
          this.$message.error(x.data.msg)
        }
        this.getModules_search()
      })
    },
    async ExportAccount() {
      this.DC_MODE = true
      const { data } = await EmployeeGetVersionArr()
      this.versions_list = data.response
      console.log(data)
      //   let para = this.filters
      //   Employee_EmployeeExportExcel(para).then((res) => {
      //           window.open('/api'+res.data.response);
      //   });
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.page = this.page
      console.log(para)
      // return
      //   let para = {
      //     page: this.page,
      //     key: this.filters.key
      //   };
      this.listLoading = true
      Employee_GetPosition_ClaimApprovalNO(para).then((res) => {
        this.total = res.data.response.dataCount
        this.users = res.data.response.data
        this.listLoading = false
      })
    },
    handlebefore(file) {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      const isLt1M = file.size / 1024 / 1024 < 20

      // if (!isJPG) {
      //   this.$message.error('上传文件只能是 JPG 格式!')
      // }
      if (!isLt1M) {
        this.$message.error('上传文件大小不能超过 20MB!')
      }
      loading.close()
      return isLt1M
    },
    handonerror() {
      console.log('超时失败')

      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      this.$message({
        message: '您的上传已超时，请再次尝试',
        type: 'error',
      })
      loading.close()
    },
    handleSuccess(file, fileLis) {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      if (file.success) {
        this.form1.filepath = file.response
        // this.UPLOAD_IF = true
        loading.close()
        this.$message({
          message: file.msg,
          type: 'success',
        })
        this.$refs.upload.clearFiles()
      } else {
        loading.close()
        this.$message({
          message: file.msg,
          type: 'error',
        })
        this.$refs.upload.clearFiles()
      }
    },
    //删除
    handleDel(ids) {
      console.log(ids)
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning',
      })
        .then(() => {
          this.listLoading = true
          //NProgress.start();
          let para = { id: ids }
          channel_Delete(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false
              return
            }
            this.listLoading = false
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: '删除成功',
                type: 'success',
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }

            this.getModules()
          })
        })
        .catch(() => {})
    },
    handleWithdraw(id) {
      // 撤回
      store_data_Reback_Store('store_id=' + id).then((res) => {
        if (res.data.success) {
          this.$message({
            message: '撤回成功',
            type: 'success',
          })
          this.getModules()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    handledetails: function (e) {
      this.$router.push({
        path: '/Employee/claim_release/approve_details',
        query: {
          id: e.ID,
          approval_data_id: e.approval_id,
          type: 'CK',
          back_url: '/Employee/claim_release/approve',
        },
      })
    },
    handleAdd() {
      this.titles = '新增'
      this.dialogVisible = true
    },

    //编辑
    handleEdit: function (e) {
      this.$router.push({
        path: '/Employee/Employee_details',
        query: {
          id: e.ID,
          type: 'EDIT',
          back_url: '/Employee/Employee_list',
        },
      })
    },
    handledetails_SalesOperation: function (ids, progress, outletnumber__c) {
      // this.details_tag('我的门店2')
      this.$router.push({
        path: '/StoreManage/add_store',
        query: {
          id: ids,
          type: 'store_ck',
          progress: progress,
          approval_type: 'store',
          outletnumber__c: outletnumber__c,
          list_SalesOperation: 1,
        },
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    //localStorage 存储数组对象的方法
    saveObjArr(name, data) {
      localStorage.setItem(name, JSON.stringify(data))
    },

    //localStorage 获取数组对象的方法
    getObjArr(name) {
      return JSON.parse(window.localStorage.getItem(name))
    },
    details_tag(name) {
      var router_list = this.getObjArr('router')
      for (let i in router_list) {
        for (let s in router_list[i].children) {
          //  console.log(999)
          if (router_list[i].children[s].id == '175') {
            //  console.log(999)
            router_list[i].children[s].name = name
            router_list[i].children[s].meta.title = name
            console.log(router_list[i].children[s].name)
            this.saveObjArr('router', router_list)
            console.log(this.getObjArr('router'))
          }
        }
      }
      //  this.getObjArr('router') = router_list
      console.log(router_list)
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - 250
    })
    console.log(this.getObjArr('router'))
    this.getModules()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
  },
}
</script>

<style scoped></style>
